<template>
  <div class="dod17" ref="dod17">
    <fieldset class="dod17_fieldset">
      <div class="form-element u-mb-base" v-bind:class="{ 'is-error': !validation.text }">
        <input
          v-model="model.text"
          type="text"
          class="form-textbox form-textbox-text"
          v-bind:class="[ (model.text) ? 'form-textbox-entered' : '' ]"
          autocomplete="off">
        <span aria-hidden="true" class="form-label">ユーザー名</span>
        <span aria-hidden="true" class="form-loading form-loading--success">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="20 6 9 17 4 12"></polyline>
          </svg>
        </span>
        <div class="form-message" aria-hidden="true">
          <div class="form-message-wrapper">error</div>
          <div class="form-message-warning"></div>
        </div>
      </div>
      <div class="form-element u-mb-base is-error">
        <div class="form-element-inputHolder">
          <input
            v-model="model.text"
            type="text"
            class="form-textbox form-textbox-text"
            v-bind:class="[ (model.text) ? 'form-textbox-entered' : '' ]"
            autocomplete="off">
          <span aria-hidden="true" class="form-label">ユーザー名</span>
          <span aria-hidden="true" class="form-loading form-loading--fail">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
              <line x1="12" y1="6.8" x2="12" y2="11.8"/>
              <line x1="12" y1="17.2" x2="12" y2="17.2"/>
            </svg>
          </span>
        </div>
        <div class="form-message" aria-hidden="true">
          <div class="form-message-wrapper">半角英字、数字、ピリオドを使用できます。</div>
        </div>
      </div>
      <div class="form-element" v-bind:class="{ 'is-error': !validation.text }">
        <div class="form-element-inputHolder">
          <input
            v-model="model.text"
            type="text"
            class="form-textbox form-textbox-text"
            v-bind:class="[ (model.text) ? 'form-textbox-entered' : '' ]"
            autocomplete="off">
          <span aria-hidden="true" class="form-label">メールアドレス</span>
          <span aria-hidden="true" class="form-loading form-loading--loading">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
              <line x1="12" y1="2" x2="12" y2="6" stroke-opacity="0.250075"></line>
              <line x1="16.24" y1="7.76" x2="19.07" y2="4.93" stroke-opacity="0.333408"></line>
              <line x1="18" y1="12" x2="22" y2="12" stroke-opacity="0.416742"></line>
              <line x1="16.24" y1="16.24" x2="19.07" y2="19.07" stroke-opacity="0.500075"></line>
              <line x1="12" y1="18" x2="12" y2="22" stroke-opacity="0.583408"></line>
              <line x1="4.93" y1="19.07" x2="7.76" y2="16.24" stroke-opacity="0.666742"></line>
              <line x1="2" y1="12" x2="6" y2="12" stroke-opacity="0.750075"></line>
              <line x1="4.93" y1="4.93" x2="7.76" y2="7.76" stroke-opacity="0.833408"></line>
            </svg>
          </span>
        </div>
        <div aria-hidden="true">
          <div class="form-message-wrapper">error</div>
          <div class="form-message-info">半角英字、数字、ピリオドを使用できます。</div>
        </div>
      </div>
    </fieldset>
  </div>
</template>

<script>
export default {
  name: 'Day17',
  data: () => ({
    model: {
      text: ''
    },
    validation: {
      text: true
    }
  }),
  beforeDestroy() {
  },
  mounted() {
  }
}
</script>

<style scoped lang="scss">
.dod17 {
  @include FR_FULLSIZE;
  overflow: hidden;
}
.dod17_fieldset {
  @include FR_CENTER(xy);
  position: absolute;
  width: 100%;
  max-width: 400px;
}

.form-selector {
  // ...
}

.form-element {
  position: relative;
}

.form-element-inputHolder {
  position: relative;
}

.form-textbox {
  appearance: none;
  font-size: 17px;
  // line-height: 1.23543;
  font-weight: 400;
  letter-spacing: -0.022em;
  display: inline-block;
  vertical-align: top;
  width: 100%;
  max-width: 100%;
  height: 3.3em;
  line-height: 3.3em;
  // padding-top: 18px;
  padding-left: 16px;
  padding-right: 16px;
  text-align: left;
  border: 1px solid #aaaaaa;
  box-shadow: 0 2px 2px rgba(#000000, 0.05);
  border-radius: 6px;
  background-color: rgba(255,255,255,0.8);
  // background-clip: padding-box;
  transition: all 200ms VAR(ease, md);
  &--textarea {
    height: 8em;
    min-height: 8em;
    max-height: 20em;
    padding-top: 1.6em;
    max-width: 100%;
    min-width: 100%;
    resize: vertical;
  }
  .is-error & {
    border-color: #de071c !important;
    // background: mix(#ffffff, #fef0f0);
  }
  &:valid[required],
  &[placeholder],
  &.form-textbox-entered {
    border-color: #888888;
  }
  &:focus {
    background-color: #ffffff !important;
    border-color: #0070c9;
    outline: 0;
    transition:
      box-shadow 1s ease-out 0ms,
      border-top 200ms linear 0ms,
      border-right 200ms linear (50ms * 1),
      border-bottom 200ms linear (50ms * 2),
      border-left 200ms linear (50ms * 2.5);
    // box-shadow: 0 0 0 3px rgba(131,192,253,0.5);
  }
}

.form-label {
  font-size: 16px;
  line-height: 1.23543;
  font-weight: 400;
  letter-spacing: -0.0175em;
  display: block;
  position: relative;
  vertical-align: top;
  color: #333333;
  user-select: none;
  pointer-events: none;
  transition: none;
  transform: translateZ(0);
  .form-textbox ~ & {
    position: absolute;
    top: 0;
    transform: translateY(18px);
    transform-origin: left center;
    backface-visibility: hidden;
    will-change: transform;
    left: 17px;
    font-weight: 500;
    color: #999;
    padding: 0;
    z-index: 1;
    // background-color: #ffffff;
    // transition-timing-function: ease-in;
    // transition-duration: 0.125s;
    transition: transform 150ms VAR(ease, md);
    &:before {
      content: '';
      position: absolute;
      right: 99%;
      top: 0;
      height: 100%;
      width: 0.5em;
      background-color: #ffffff;
      transform: translateZ(0);
    }
    &:after {
      content: '';
      position: absolute;
      left: 99%;
      top: 0;
      height: 100%;
      width: 0.5em;
      background-color: #ffffff;
      transform: translateZ(0);
    }
  }
  .form-textbox:focus ~ &,
  .form-textbox:valid[required] ~ &,
  .form-textbox[placeholder] ~ &,
  .form-textbox.form-textbox-entered ~ & {
    transform: translateY(-45%) scale(0.75);
    transition: transform 250ms VAR(ease, md);
    background-color: #ffffff;
  }
  .form-textbox:focus ~ & {
    color: #0070c9 !important;
  }
  .form-textbox:valid[required] ~ &,
  .form-textbox[placeholder] ~ &,
  .form-textbox.form-textbox-entered ~ & {
    color: #777777;
  }
  .is-error .form-textbox ~ & {
    color: #de071c !important;
  }
}

/**************************************************
 * Style > 読み込みアイコン
 **************************************************/
.form-loading {
  @include FR_FLEX_LAYOUT(center, center);
  @include FR_WH(28px);
  position: absolute;
  top: 50%;
  margin-top: -14px;
  right: 17px;
  pointer-events: none;
}
.form-loading--loading,
.form-loading--fail,
.form-loading--success {
  &:before {
    @include FR_FULLSIZE;
    content: '';
    border-radius: 50%;
  }
  svg {
    @include FR_FULLSIZE;
    padding: 5px;
    position: absolute;
    color: #ffffff;
    display: block;
  }
}
.form-loading--loading {
  animation: loadingRoate 3.3s ease 0s infinite;
  svg {
    padding: 0;
    color: #000000;
    animation: loadingRoate 1.5s linear 0s infinite;
  }
}
.form-loading--success {
  &:before {
    background-color: rgba(green, 0.7);
  }
}
.form-loading--fail {
  &:before {
    background-color: rgba(#de071c, 0.8);
  }
}
@keyframes loadingRoate {
  100% {
    transform: rotate(360deg);
  }
}

/**************************************************
 * form > メッセージ
 **************************************************/
.form-message-wrapper {
  font-size: 12px;
  line-height: 1.5;
  font-weight: 400;
  letter-spacing: 0;
  display: none;
  margin-top: 8px;
  margin-bottom: 8px;
  letter-spacing: .006em;
  .is-error & {
    display: block;
    color: #de071c;
  }
}
.form-message-warning {
  font-size: 12px;
  line-height: 1.5;
  font-weight: 400;
  letter-spacing: 0;
  display: none;
  letter-spacing: .006em;
  margin-bottom: 8px;
  margin-top: 8px;
}
.form-message-info {
  color: COLOR('text', 'gray');
  font-size: 12px;
  line-height: 1.5;
  font-weight: 400;
  letter-spacing: 0;
  letter-spacing: .006em;
  margin-bottom: 8px;
  margin-top: 8px;
}
</style>
